// themes/your-theme/assets/js/utils/add-to-cart.js
import prestashop from 'prestashop';
import $ from 'jquery';

prestashop.blockcart = prestashop.blockcart || {};

prestashop.blockcart.showModal = (html) => {
  function getBlockCartModal() {
    return $('#blockcart-modal');
  }
  let $blockCartModal = getBlockCartModal();

  if ($blockCartModal.length) {
    $blockCartModal.remove();
  }
  $('body').append(html);
  $blockCartModal = getBlockCartModal();
  $blockCartModal.modal('show').on('hidden.bs.modal', (event) => {
    prestashop.emit('updateProduct', {
      reason: event.currentTarget.dataset,
      event,
    });
  });
};

export function handleAddToCart(button, productId, quantity, showModal = true) {
  const originalButtonText = button.innerHTML;
  button.innerHTML = '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Adding...';
  button.disabled = true;

  fetch(`${prestashop.urls.base_url}index.php?controller=cart&add=1&action=update&id_product=${productId}&token=${prestashop.static_token}&ajax=1`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: `qty=${quantity}`,
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.success) {
        // First update the cart data
        fetch(`${prestashop.urls.pages.cart}?ajax=1&action=refresh`)
          .then((res) => res.json())
          .then((cartData) => {
            prestashop.emit('updateCart', {
              reason: {
                idProduct: productId,
                idProductAttribute: 0,
                linkAction: 'add-to-cart',
              },
              resp: cartData,
            });
          });

        // Show modal only if showModal is true and modal HTML is available
        if (showModal && data.modal) {
          prestashop.blockcart.showModal(data.modal);
        }

        button.innerHTML = '<i class="bi bi-check"></i> Added';
      } else {
        button.innerHTML = '<i class="bi bi-exclamation-triangle"></i> Error';
      }
    })
    .catch((error) => {
      console.error('Error adding to cart:', error);
      button.innerHTML = '<i class="bi bi-exclamation-triangle"></i> Error';
    })
    .finally(() => {
      setTimeout(() => {
        button.innerHTML = originalButtonText;
        button.disabled = false;
      }, 2000);
    });
}
